import { render, staticRenderFns } from "./Attention.vue?vue&type=template&id=042f79fa&scoped=true&"
import script from "./Attention.vue?vue&type=script&lang=js&"
export * from "./Attention.vue?vue&type=script&lang=js&"
import style0 from "./Attention.vue?vue&type=style&index=0&id=042f79fa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "042f79fa",
  null
  
)

export default component.exports